import type { Product, Category } from './types';

export const categories: Category[] = [
  {
    id: 1,
    name: '云电脑',
    children: [
      { id: 11, name: '标准型' },
      { id: 12, name: '高性能型' },
    ],
  },
  {
    id: 2,
    name: 'GPU服务器',
    children: [
      { id: 21, name: '图形渲染' },
      { id: 22, name: 'AI训练' },
    ],
  },
  {
    id: 3,
    name: 'AIGC',
    children: [
      { id: 31, name: '文本生成' },
      { id: 32, name: '图像生成' },
    ],
  },
  {
    id: 4,
    name: 'PC Farm',
    children: [
      { id: 41, name: '办公型' },
      { id: 42, name: '专业型' },
    ],
  },
];

export const datacenters = [
  '北京-朝阳机房',
  '上海-浦东机房',
  '深圳-南山机房',
  '广州-天河机房',
  '成都-高新机房',
  '杭州-滨江机房',
];

export const operatingSystems = [
  'Windows 10 专业版',
  'Windows 11 专业版',
  'Windows Server 2019',
  'Windows Server 2022',
  'Ubuntu 20.04 LTS',
  'Ubuntu 22.04 LTS',
  'CentOS 7',
  'CentOS 8',
];

export const pcFarmModels = [
  'Dell OptiPlex 7090',
  'HP EliteDesk 800 G8',
  'Lenovo ThinkCentre M90a',
  'Dell Precision 3660',
];

export const mockProducts: Product[] = [
  {
    id: 1,
    name: '标准云电脑 - 4核8G',
    categoryId: 11,
    categoryName: '云电脑',
    subCategoryName: '标准型',
    isOnline: true,
    sort: 100,
    tags: ['热卖', '新品'],
    description: '适合日常办公和轻度开发使用',
    configType: 'cpu',
    cpuCores: 4,
    memory: 8,
    systemDisk: 100,
    bandwidth: {
      download: 50,
      upload: 20,
    },
    operatingSystems: ['Windows 10 专业版', 'Windows 11 专业版', 'Ubuntu 20.04 LTS'],
    limitPerUser: 5,
    datacenters: ['北京-朝阳机房', '上海-浦东机房'],
    salesPeriod: {
      type: 'permanent',
    },
    targetUsers: ['normal', 'school', 'enterprise'],
    pricingMethods: ['hourly', 'monthly'],
    hourlyPrice: 2.5,
    monthlyPackages: [
      {
        id: 1,
        name: '不限时长',
        duration: 0,
        timeSlot: { type: 'unlimited' },
        price: 1200,
        sort: 1,
        isEnabled: true,
      },
      {
        id: 2,
        name: '100小时/月',
        duration: 100,
        timeSlot: { type: 'unlimited' },
        price: 200,
        sort: 2,
        isEnabled: true,
      },
    ],
    monthlyDurations: [
      { months: 1, isEnabled: true },
      { months: 3, isEnabled: true, discount: { type: 'discount', value: 9.5 } },
      { months: 6, isEnabled: true, discount: { type: 'reduction', value: 200 } },
      { months: 12, isEnabled: true, discount: { type: 'gift', value: 30, unit: '天' } },
    ],
    createdAt: '2024-01-15 10:30:00',
  },
  {
    id: 2,
    name: 'GPU渲染服务器 - T4',
    categoryId: 21,
    categoryName: 'GPU服务器',
    subCategoryName: '图形渲染',
    isOnline: true,
    sort: 95,
    tags: ['热卖'],
    description: '专业图形渲染，支持3D建模和视频处理',
    configType: 'gpu',
    cpuCores: 8,
    memory: 32,
    systemDisk: 200,
    gpu: 'T4',
    bandwidth: {
      download: 100,
      upload: 50,
    },
    operatingSystems: ['Windows 10 专业版', 'Windows Server 2019', 'Ubuntu 20.04 LTS'],
    limitPerUser: 3,
    datacenters: ['北京-朝阳机房', '深圳-南山机房'],
    salesPeriod: {
      type: 'range',
      startTime: '2024-01-01 00:00:00',
      endTime: '2024-12-31 23:59:59',
    },
    targetUsers: ['enterprise'],
    pricingMethods: ['hourly', 'package'],
    hourlyPrice: 8.5,
    packagePlans: [
      {
        id: 1,
        name: '30天/100小时',
        validDays: 30,
        usageHours: 100,
        timeSlot: { type: 'unlimited' },
        price: 800,
        sort: 1,
        discountedPrice: 800,
      },
      {
        id: 2,
        name: '60天/200小时/工作时段',
        validDays: 60,
        usageHours: 200,
        timeSlot: { type: 'limited', start: '09:00', end: '18:00' },
        price: 1500,
        discount: { type: 'discount', value: 8.5 },
        discountedPrice: 1275,
        sort: 2,
      },
    ],
    createdAt: '2024-01-20 14:20:00',
  },
  {
    id: 3,
    name: '高性能云电脑 - 16核32G',
    categoryId: 12,
    categoryName: '云电脑',
    subCategoryName: '高性能型',
    isOnline: true,
    sort: 90,
    tags: ['新品', '促销'],
    description: '适合大型项目开发和数据处理',
    configType: 'cpu',
    cpuCores: 16,
    memory: 32,
    systemDisk: 500,
    bandwidth: {
      download: 100,
      upload: 50,
    },
    operatingSystems: ['Windows 11 专业版', 'Windows Server 2022', 'Ubuntu 22.04 LTS'],
    limitPerUser: 2,
    datacenters: ['上海-浦东机房', '杭州-滨江机房'],
    salesPeriod: {
      type: 'permanent',
    },
    targetUsers: ['normal', 'enterprise'],
    pricingMethods: ['hourly', 'monthly'],
    hourlyPrice: 6.8,
    monthlyPackages: [
      {
        id: 1,
        name: '不限时长',
        duration: 0,
        timeSlot: { type: 'unlimited' },
        price: 3500,
        sort: 1,
        isEnabled: true,
      },
    ],
    monthlyDurations: [
      { months: 1, isEnabled: true },
      { months: 6, isEnabled: true, discount: { type: 'discount', value: 9.0 } },
      { months: 12, isEnabled: true, discount: { type: 'gift', value: 60, unit: '天' } },
    ],
    createdAt: '2024-02-01 09:15:00',
  },
  {
    id: 4,
    name: 'AI训练服务器 - 5090',
    categoryId: 22,
    categoryName: 'GPU服务器',
    subCategoryName: 'AI训练',
    isOnline: false,
    sort: 85,
    tags: ['新品'],
    description: '顶级AI训练性能，支持大模型训练',
    configType: 'gpu',
    cpuCores: 32,
    memory: 64,
    systemDisk: 500,
    gpu: '5090',
    bandwidth: {
      download: 100,
      upload: 100,
    },
    operatingSystems: ['Ubuntu 22.04 LTS', 'CentOS 8'],
    limitPerUser: 1,
    datacenters: ['北京-朝阳机房'],
    salesPeriod: {
      type: 'permanent',
    },
    targetUsers: ['enterprise'],
    pricingMethods: ['hourly'],
    hourlyPrice: 25.0,
    createdAt: '2024-02-10 16:45:00',
  },
  {
    id: 5,
    name: 'PC Farm 办公型',
    categoryId: 41,
    categoryName: 'PC Farm',
    subCategoryName: '办公型',
    isOnline: true,
    sort: 80,
    tags: ['热卖'],
    description: '企业办公专用，稳定可靠',
    configType: 'pcfarm',
    cpuCores: 4,
    memory: 16,
    systemDisk: 256,
    pcFarmModel: 'Dell OptiPlex 7090',
    bandwidth: {
      download: 50,
      upload: 20,
    },
    operatingSystems: ['Windows 10 专业版', 'Windows 11 专业版'],
    limitPerUser: 10,
    datacenters: ['北京-朝阳机房', '上海-浦东机房', '深圳-南山机房'],
    salesPeriod: {
      type: 'permanent',
    },
    targetUsers: ['enterprise'],
    pricingMethods: ['monthly'],
    monthlyPackages: [
      {
        id: 1,
        name: '不限时长',
        duration: 0,
        timeSlot: { type: 'unlimited' },
        price: 800,
        sort: 1,
        isEnabled: true,
      },
    ],
    monthlyDurations: [
      { months: 1, isEnabled: true },
      { months: 12, isEnabled: true, discount: { type: 'reduction', value: 1000 } },
    ],
    createdAt: '2024-01-25 11:30:00',
  },
  {
    id: 6,
    name: 'AIGC文本生成服务',
    categoryId: 31,
    categoryName: 'AIGC',
    subCategoryName: '文本生成',
    isOnline: true,
    sort: 75,
    tags: ['新品', '促销'],
    description: '基于大语言模型的文本生成服务',
    configType: 'gpu',
    cpuCores: 16,
    memory: 32,
    systemDisk: 200,
    gpu: '5070',
    bandwidth: {
      download: 100,
      upload: 50,
    },
    operatingSystems: ['Ubuntu 22.04 LTS'],
    limitPerUser: 3,
    datacenters: ['上海-浦东机房', '杭州-滨江机房'],
    salesPeriod: {
      type: 'permanent',
    },
    targetUsers: ['normal', 'school', 'enterprise'],
    pricingMethods: ['hourly', 'package'],
    hourlyPrice: 12.0,
    packagePlans: [
      {
        id: 1,
        name: '30天/50小时',
        validDays: 30,
        usageHours: 50,
        timeSlot: { type: 'unlimited' },
        price: 500,
        discount: { type: 'gift', value: 10 },
        discountedPrice: 500,
        sort: 1,
      },
    ],
    createdAt: '2024-02-05 13:20:00',
  },
];
